// The usual colors of the sides of well-known wars on the map: the Union
// in blue and the Confederacy in grey, redcoats in red, the Red Army in
// red, field grey for the German side in both world wars. A side is its
// label in event_participants.side, the same in a war, its campaigns and
// its battles. Sides not listed here get the remaining force colors.

export const RED = "#ff7a7a";
export const BLUE = "#5cc8ff";
export const YELLOW = "#ffcf5c";
export const GREEN = "#4fd1a5";
export const ORANGE = "#ff9f5c";
const GREY = "#aeb6c4"; // Confederate grey
const FIELD_GREY = "#9fae8f"; // German field grey
const WHITE = "#efe6cf"; // Bourbon white, the Whites

const BY_SIDE = {
  // American Revolutionary War, War of 1812, Mexican-American and
  // Spanish-American Wars
  American: BLUE,
  British: RED,
  French: WHITE,
  Spanish: YELLOW,
  "United States": BLUE,
  "United Kingdom": RED,
  Mexico: GREEN,
  Spain: YELLOW,
  // French Revolutionary and Napoleonic Wars
  France: BLUE,
  "French Empire and allies": BLUE,
  Coalition: RED,
  // American Civil War
  Union: BLUE,
  Confederacy: GREY,
  // Nineteenth-century wars in Europe and Asia
  Russia: GREEN,
  "Russia and allies": GREEN,
  "Ottoman Empire": RED,
  "Prussia and allies": BLUE,
  "Austria and allies": YELLOW,
  Germany: FIELD_GREY,
  Japan: RED,
  China: BLUE,
  "Balkan League": BLUE,
  "United Kingdom and allies": RED,
  "South African Republic and allies": GREEN,
  "Qing dynasty": YELLOW,
  "Taiping Heavenly Kingdom": RED,
  "Eight-Nation Alliance": BLUE,
  "Qing China and Boxers": YELLOW,
  // World Wars
  Allies: BLUE,
  "Central Powers": FIELD_GREY,
  Axis: FIELD_GREY,
  // Civil wars and the Cold War
  Reds: RED,
  Whites: WHITE,
  Communists: RED,
  Nationalists: BLUE,
  Republicans: RED,
  "South Korea and UN forces": BLUE,
  "United Nations": BLUE,
  "North Korea and allies": RED,
  "South Vietnam and allies": BLUE,
  "North Vietnam and allies": RED,
  "Soviet Union and Afghan government": RED,
  Mujahideen: GREEN,
  NATO: BLUE,
  // Arab-Israeli wars
  Israel: BLUE,
  "Arab states": GREEN,
  // South Asia
  India: ORANGE,
  "India and Bangladesh": ORANGE,
  Pakistan: GREEN,
};

// The usual color of a side, or null.
export function usualSideColor(side) {
  return (side && BY_SIDE[side]) || null;
}
